import React from 'react';
import {Field} from 'react-final-form';
import {FormFieldCheckbox} from '@yandex-data-ui/cloud-components';

import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

interface PreemptibleFieldProps extends WithTranslationProps {
    name: string;
}

const PreemptibleField: React.FC<PreemptibleFieldProps> = ({name, i18nK}) => (
    <CalculatorFormLayout.Row
        title={i18nK('field_preemptible')}
        note={i18nK('context_preemptible')}
    >
        <Field name={`${name}preemptible`}>
            {(fieldProps) => <FormFieldCheckbox {...fieldProps} size="l" />}
        </Field>
    </CalculatorFormLayout.Row>
);

export default withTranslation('calculator')(PreemptibleField);
